import { Context, ExtraContext } from '@utilitywarehouse/tracking-core';

import { BundleBasketFragment } from '@generated/gql/graphql';
import { parseCoreServicesEntity } from '@tracking/utils';
import { findTrackingContextIndex } from '@tracking/utils/findTrackingContextIndex';

const updateTrackingContext = (
  contexts: ExtraContext<Context>[],
  basket: Nullable<BundleBasketFragment>
): ExtraContext<Context>[] => {
  if (!basket) {
    return contexts;
  }

  const ctxIndex = findTrackingContextIndex(contexts, 'signup_core_services');

  // Should never happen
  if (ctxIndex === -1) {
    return contexts;
  }

  const updatedContext = parseCoreServicesEntity(basket);

  if (!updatedContext) {
    return contexts;
  }

  contexts[ctxIndex].data = { ...updatedContext };

  return contexts;
};

export { updateTrackingContext };
